module.exports = __webpack_public_path__ + "img/gift4-01-c04-y2.382b709c.png";